module.exports = __webpack_public_path__ + "images/apriliaded915254262e54f1e817b0da1eb936f.png";